import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'
import CustomTheme from 'theme'

export const StyledForm = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;

    form {
        display: flex;
        flex-direction: column;
        flex: 1 0;
    }

    .form__validate-form {
        margin-top: 3rem;
        display: flex;
        justify-content: space-around;
    }

    .form__validate-form > .validate-form__field {
        border: none;
        width: 40px;
        height: 50px;
        padding: 0 5px;
        font-size: ${theme.fontSizes[5]};
        border-bottom: solid 1px #666;
        font-weight: ${theme.fontWeights.bold};
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
        text-align: center;
        appearance: none;
        -webkit-appearance: none;
        border-radius: 0;

        &:focus {
            outline: none;
            border-bottom-color: ${theme.colors.brand.primary[50]};
        }
        &--success,
        &--success:focus {
            border-bottom-color: #22723a;
        }
        &--error,
        &--error:focus {
            border-bottom-color: #c02a3c;
        }
    }

    .form__validate-form__resend-token {
        margin-top: 1.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .footer__paragraph {
        width: 100%;
        text-align: center;
        color: #666;
        font-size: 1rem;
        line-height: 1.5rem;
        margin-bottom: 1rem;

        > strong {
            display: inline-block;
            width: 2.5rem;
            text-align: left;
            color: ${theme.colors.primary};
        }

        &--ask-for-action {
            font-size: 1rem;
            color: #363636;
            max-width: 312px;
            font-weight: 500;
        }
    }

    .footer__button-resend-token {
        width: 100%;
        margin-bottom: 1rem;
        max-width: 400px;

        ${CustomTheme.breakPoint.desktop} {
            max-width: 312px;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;

        form {
            display: initial;
            height: initial;
        }
    }
`
